import React, { useRef } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import PlaceIcon from '@mui/icons-material/Place';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import RadarIcon from '@mui/icons-material/Radar';
import addnoteSound from '../assets/audio/addnote.mp3';

function BottomActionBar({ onAddNote, onAddWaypoint, onResetLocation, showResetLocation, onRadarScan }) {
  const addnoteAudioRef = useRef(null);
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 24,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1000,
      }}
    >
      {/* Action Bar Container */}
      <Box
        sx={{
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          borderRadius: '28px',
          padding: '12px 16px',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          border: '1px solid rgba(255, 255, 255, 0.15)',
          backdropFilter: 'blur(20px) saturate(180%)',
          WebkitBackdropFilter: 'blur(20px) saturate(180%)',
          transition: 'all 0.3s ease',
        }}
      >
        {showResetLocation && (
          <>
            <Tooltip title="Reset to My Location" placement="top" arrow>
              <IconButton
                onClick={onResetLocation}
                sx={{
                  color: 'white',
                  padding: '12px',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  },
                }}
              >
                <MyLocationIcon sx={{ fontSize: 28 }} />
              </IconButton>
            </Tooltip>

            <Box
              sx={{
                width: '1px',
                height: '32px',
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                mx: 0.5,
              }}
            />
          </>
        )}

        <Tooltip title="Add Note" placement="top" arrow>
          <IconButton
            onClick={() => {
              // Play add note sound
              if (addnoteAudioRef.current) {
                addnoteAudioRef.current.play().catch(err => console.log('Audio play failed:', err));
              }
              onAddNote();
            }}
            sx={{
              color: 'white',
              padding: '12px',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            <NoteAddIcon sx={{ fontSize: 28 }} />
          </IconButton>
        </Tooltip>

        <Box
          sx={{
            width: '1px',
            height: '32px',
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            mx: 0.5,
          }}
        />

        <Tooltip title="Radar Scan" placement="top" arrow>
          <IconButton
            onClick={onRadarScan}
            sx={{
              color: 'white',
              padding: '12px',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            <RadarIcon sx={{ fontSize: 28 }} />
          </IconButton>
        </Tooltip>

        <Box
          sx={{
            width: '1px',
            height: '32px',
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            mx: 0.5,
          }}
        />

        <Tooltip title="Add Waypoint" placement="top" arrow>
          <IconButton
            onClick={onAddWaypoint}
            sx={{
              color: 'white',
              padding: '12px',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            <PlaceIcon sx={{ fontSize: 28 }} />
          </IconButton>
        </Tooltip>
      </Box>

      {/* Hidden audio element */}
      <audio ref={addnoteAudioRef} src={addnoteSound} preload="auto" />
    </Box>
  );
}

export default BottomActionBar;
